__webpack_require__.p = "https://pre-trade.kido.vn/";